import { useTranslation } from 'react-i18next'

import { RENTAL_PORTAL_VIEWING_STATUSES } from '../../../../constants/rentalPortal'
import { getQaSelector } from '../../../../utils/common'
import { EntityStatus } from '../../../Entity'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useViewingProfileContext } from '../RentalPortalViewingProfile.hooks'

import { QA_NAME_VIEWING_PROFILE_OUTCOME } from './RentalPortalViewingProfileOutcome.constants'
import { getViewingOutcomeRecordLabel } from './RentalPortalViewingProfileOutcome.utils'

import * as styles from './RentalPortalViewingProfileOutcome.module.css'

function RentalPortalViewingProfileOutcome({ locale, timezone }) {
  const { t } = useTranslation()

  const { isInitiated, viewingData } = useViewingProfileContext()

  const outcome = viewingData?.outcome

  return outcome ? (
    <Widget
      {...getQaSelector({ value: QA_NAME_VIEWING_PROFILE_OUTCOME })}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated}
      title={t('RentalPortal.ViewingProfileOutcomeTitleKey')}
    >
      <div className={styles.body}>
        <div className={styles.head}>
          <EntityStatus
            id={outcome.status}
            statuses={RENTAL_PORTAL_VIEWING_STATUSES}
          />
          <Text isSecondary>
            {getViewingOutcomeRecordLabel({ locale, outcome, t, timezone })}
          </Text>
        </div>
        <Text isSecondary={!outcome.note}>
          {outcome.note ?? t('RentalPortal.ViewingProfileOutcomeNoteEmptyKey')}
        </Text>
      </div>
    </Widget>
  ) : null
}

export default RentalPortalViewingProfileOutcome
